import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

/**
 * API
 */
import usersAPI from "@/api/users";
import { GetCurrentUserResponse } from "@/api/users/get-current-user.response";
import { GetCurrentUserCharactersResponse } from "@/api/users/get-current-user-characters.response";

/**
 * VueX module for user profile.
 */
@Module({
	namespaced: true
})
export default class Profile extends VuexModule {
	/** State */
	userDetails: GetCurrentUserResponse | null = null;

	/** Mutations */
	@Mutation
	FETCH_CHARACTERS(characters: GetCurrentUserCharactersResponse.Character[]) {
		if (this.userDetails) {
			this.userDetails.characters = characters;
		}
	}

	@Mutation
	FETCH_USER_DETAILS(userDetails: GetCurrentUserResponse) {
		this.userDetails = userDetails;
	}

	@Mutation
	SET_USER_DETAILS(userDetails: GetCurrentUserResponse) {
		this.userDetails = userDetails;
	}

	/** Actions */
	@Action({commit: "FETCH_CHARACTERS"})
	async fetchCharacters() {
		return await usersAPI.getCharacters();
	}

	@Action({commit: "FETCH_USER_DETAILS"})
	async fetchUserDetails() {
		return await usersAPI.getDetails();
	}

	@Action({commit: "FETCH_USER_DETAILS"})
	async setUserDetails(data: GetCurrentUserResponse) {
		return data;
	}
}